import { platform } from '@/shared/lib/platform/platform'

/** BACK-16: preserva o estado no Android; versões sem minimizar usam a saída. */
export const exitOrMinimizeApp = async (): Promise<void> => {
  if (!platform.isNative()) return

  const { App } = await import('@capacitor/app')
  if (typeof App.minimizeApp === 'function') {
    try {
      await App.minimizeApp()
      return
    } catch {
      // Compatibilidade com um binário nativo que ainda não implemente minimizar.
    }
  }
  await App.exitApp()
}

/**
 * Registra handler do botão voltar nativo (Android/Capacitor).
 * Na PWA retorna unsubscribe vazio.
 */
export const onNativeBackButton = (handler: () => void): (() => void) => {
  if (!platform.isNative()) {
    return () => {}
  }

  let disposed = false
  let removeListener: (() => void) | undefined

  void import('@capacitor/app')
    .then(({ App }) =>
      App.addListener('backButton', () => {
        if (disposed) {
          return
        }
        handler()
      }),
    )
    .then((handle) => {
      if (disposed) {
        void handle.remove()
        return
      }
      removeListener = () => {
        void handle.remove()
      }
    })

  return () => {
    disposed = true
    removeListener?.()
  }
}
